'use strict';

// Entry point — esbuild bundelt dit naar public/js/app.js
import './preferences.js'; // Registreert beforeunload listener
import './app-core.js';    // App object + DOMContentLoaded
